import { IPromise, IQService, IScope } from "angular";

export const eventToPromise = <T = void>($q: IQService, $scope: IScope, eventName: string): IPromise<T> =>
  $q<T>((resolve) => {
    const unsubscribe = $scope.$on(eventName, (evt, arg) => {
      unsubscribe();
      resolve(arg);
    });
  });
